// Centralized placeholder external links — easy to update later
export const LINKS = {
  jotform: "https://form.jotform.com/your-proposal-form-id",
  financialCents: "https://app.financial-cents.com/portal",
  calendly: "https://calendly.com/linehaulbooks",
  discoveryCall: "https://calendly.com/linehaulbooks/introduction-call",
  qbo: "https://quickbooks.intuit.com/online/",
  loomQboInvite: "https://www.loom.com/embed/placeholder-qbo-invite",
  loomBankFeeds: "https://www.loom.com/embed/placeholder-bank-feeds",
  loomCreditCards: "https://www.loom.com/embed/placeholder-credit-cards",
  loomUploadDocs: "https://www.loom.com/embed/placeholder-upload-docs",
  loomPortal: "https://www.loom.com/embed/placeholder-portal-usage",
  loomFaqs: "https://www.loom.com/embed/placeholder-faqs",
};

export const COMPANY = {
  name: "Linehaul Books",
  tagline: "Always Within Reach; Never In the Way",
  email: "info@linehaulbooks.com",
  phone: "(636) 422-4382",
  phoneTel: "+16364224382",
  location: "Midwest, USA",
  hours: "Mon–Fri · 8a–5p CST · Async 24/7",
};
